import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import MaterialSnackbar from '@material-ui/core/Snackbar';

import { closeSnackBar } from '@actions/snackBar';

import {
  isError,
  isOpen,
  message,
} from '@selectors/snackBar';

const SnackBar = ({
  closeSnackBar,
  isError,
  isOpen,
  message,
}) => (
  <MaterialSnackbar
    anchorOrigin={{
      horizontal: 'right',
      vertical: 'bottom',
    }}
    open={isOpen}
    onClose={closeSnackBar}
    autoHideDuration={5000}
    message={message}
    ContentProps={{
      style: {
        backgroundColor: isError ? '#ff4e00' : '#7ac143',
      },
    }}
  />
);

SnackBar.propTypes = {
  closeSnackBar: PropTypes.func.isRequired,
  isError: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  isError: isError(state),
  isOpen: isOpen(state),
  message: message(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  closeSnackBar,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SnackBar);



// WEBPACK FOOTER //
// ./src/routes/containers/SnackBar/SnackBar.js